const initRecipeRating = () => {
  if (!Object.hasOwn(window, "recipeRatingData")) {
    return
  }

  let { rateUrl, recipePk, ratingInPercents } = window.recipeRatingData
  const key = "recipe_rating_" + recipePk.toString()
  let ratingEnabled = localStorage.getItem(key) === null
  const widget = document.querySelector(".star-rating-widget")

  if (ratingEnabled) {
    widget.classList.add("star-rating-widget--enabled")
  } else {
    document.querySelector(".already-rated-msg").style.display = null
  }

  const starsOverlay = document.querySelector(".star-rating-widget__stars--overlay")
  document.querySelectorAll(".rate-recipe").forEach((el) => {
    el.addEventListener("click", () => {
      if (!ratingEnabled) {
        return
      }
      const fd = new FormData()
      fd.append("recipe", recipePk)
      fd.append("rating", el.dataset.rating)

      const request = new Request(rateUrl, {
        method: "post",
        headers: {
          "X-CSRFToken": document.querySelector("[name=csrfmiddlewaretoken]").value,
        },
        mode: "same-origin",
        body: fd,
      })
      fetch(request)
        .then((response) => {
          if (response.ok) {
            return response.json()
          } else {
            console.error("Bad request.")
          }
        })
        .then((result) => {
          ratingInPercents = result.rating_in_percents
          starsOverlay.style.width = ratingInPercents + "%"
          ratingEnabled = false
          localStorage.setItem(key, "1")
          widget.classList.remove("star-rating-widget--enabled")
          document.querySelector(".rating-thank-you-msg").style.display = null
        })
        .catch((error) => {
          console.error("Error:", error)
        })
    })
    el.addEventListener("mouseenter", () => {
      if (ratingEnabled) {
        starsOverlay.style.width = (el.dataset.rating * 100) / 5 + "%"
      }
    })
  })
  document.querySelector(".star-rating-widget__container").addEventListener("mouseleave", () => {
    starsOverlay.style.width = ratingInPercents + "%"
  })
}

export default initRecipeRating
